/** Import hooks */

import { FiltersCollection }        from "../../../../Datasets/Tyres";

/** Import models */

import TyresAttributes              from "../../../../Models/TyresFilters";

/** Import components */

import SingleFilter                 from "./Filters/Filter";

import ComponentLoader              from "../../../Layout/Loaders/Loader";

import ClearFilters                 from "./Filters/ClearFilters";

import { Fragment }                 from "react";

import SingleQtyTiresFilter         from "./Filters/SingleTires";

import ShowSetTires                 from "./Filters/ShowSetTires";

/** @import icons */

import { GrClose }                  from "react-icons/gr";

import { FaAngleLeft }              from "react-icons/fa";

/**
 * 
 * @returns Filters list component
 * 
 */

const Filters = ( { attributes } ) => { const 

    { loading, data } = TyresAttributes (),

    LoadFilters = () => {

        if ( loading ) return <ComponentLoader minified={ true } />

        return (

            <Fragment>

                <SingleQtyTiresFilter />

                <ShowSetTires />

                { FiltersCollection ( data ).map ( ( filter, index ) => <SingleFilter 
                
                    key={ index } 
                
                    name={ filter.title } 
                
                    toggle={ filter.toggle }

                    header={ filter.header }
                    
                    position={ filter.position }>

                        { filter.content }

                </SingleFilter> ) }

            </Fragment>

        );

    }

    /** Return component */

    return ( <div className="widget catalog-filters-widget" ref={ attributes.element }>

        <div className="close-mobile-filters">

            <button onClick={ () => {

                ( attributes.view ) ? attributes.set ( false ) : attributes.set ( true );

                return attributes.element.current.classList.remove ( "mobile-filters-state" );

            } }>

                <GrClose />

            </button>

        </div>

        <button className="sticky-close" onClick={ () => {

            ( attributes.view ) ? attributes.set ( false ) : attributes.set ( true );

            return attributes.element.current.classList.remove ( "mobile-filters-state" );

        } }>

            <FaAngleLeft />

        </button>

        <ClearFilters />

        <LoadFilters />

        <ClearFilters />

    </div> );

}

/** Export component */
 
export default Filters;